import { Injectable } from '@angular/core';


import { Jurisdicionado } from '../models/Jurisdicionado';

/*
  Generated class for the JurisdicionadoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class JurisdicionadoService{

  jurisdicionado : Jurisdicionado;

  constructor() {
  }

  public setJurisdicionado(idJurisdicionado, dsJurisdicionado) {
    this.jurisdicionado = new Jurisdicionado();
    this.jurisdicionado.setJurisdicionado(idJurisdicionado, dsJurisdicionado);
  }

  public getJurisdicionado() {
    return this.jurisdicionado;
  }
}



// WEBPACK FOOTER //
// ./src/providers/jurisdicionado-service.ts